import { render, staticRenderFns } from "./HandoverDocuments.vue?vue&type=template&id=76b72a70&scoped=true"
import script from "./HandoverDocuments.vue?vue&type=script&lang=js"
export * from "./HandoverDocuments.vue?vue&type=script&lang=js"
import style0 from "./HandoverDocuments.vue?vue&type=style&index=0&id=76b72a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b72a70",
  null
  
)

export default component.exports